import React from "react";

interface AddButtonChildrenProps {
  children: React.ReactNode;
}

const AddButtonChildren = ({ children }: AddButtonChildrenProps) => {
  return (
    <div className="flex-content-center">
      <i className="fas fa-plus mr-2" />
      {children}
    </div>
  );
};

export default AddButtonChildren;
